import { date as commonDate } from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

import {
  getDefaultDashboardDisplayEndDate,
  getDefaultDashboardDisplayStartDate,
} from 'packages/common-frontend/constants';

// @jendevelops [receivables-dashboard TODO]: consolidate date utils used for date picker to reusable hook in common-frontend

// ======= Date Utils =======//

export type DateRange = {
  dateStart: Util.FullDateStr;
  dateEnd: Util.FullDateStr;
};

export type ChartDateRange = {
  chartDataStartDate: Date;
  chartDataEndDate: Date;
};

/**
 * Generates initial date range to Today -> 3 years ago
 */
export const generateInitialDateRange = (): DateRange => {
  return {
    dateStart: getDefaultDashboardDisplayStartDate(),
    dateEnd: getDefaultDashboardDisplayEndDate(),
  };
};

export const generateFullDateStrDateRangeFromOffset = ({
  dateEnd,
  offsetDays,
}: {
  dateEnd?: Util.FullDateStr;
  offsetDays: number;
}): DateRange => {
  const newDateEnd = dateEnd || commonDate.currentDateStr();
  const dateStart = commonDate.addDays(newDateEnd, offsetDays);

  return {
    dateStart,
    dateEnd: newDateEnd,
  };
};
